import { dashboardExperienceResource } from './DashboardExperienceResource';

export const dashboardResources = [
	dashboardExperienceResource,
	// TODO: AVP route resources here
];
